import React from "react";

import { connect } from "react-redux";
import {
    reset,
    remove,
    list,
    isLoading,
    isLoaded,
    getMeta,
    getList,
    getError,
    isSecondaryLoading,
    downloadScorecard,
    accept,
} from "../../../../redux/actions/manager/qa/list";

import {
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    CACHE_VENDOR,
    getVendorsForSelect,
} from "../../../../redux/actions/cache/interface";

import FullList from "../../../../core/components/listPattern/list";
import listContainer from "../../../../core/components/listPattern/container";

import { basicColumns } from "./fields";
import Filters from "./filters";
import Comments from "./comments";

const Tabla = (props) => {
    return (
        <FullList
            {...props}
            titulo={"QA"}
            subtitulo="List"
            onSearchByText={(text) => props.onUpdateFilters({ text })}
            resize
            expandable={{
                expandedRowRender: (record) => <Comments record={record} />,
                rowExpandable: (record) => (record.timeline || []).length > 0,
                expandedRowClassName: (record, index, indent) => "table-details",
            }}
        >
            <Filters filters={props.parameters} onUpdateFilters={props.onFilterChangeUpdateUrl} {...props} />
        </FullList>
    );
};

const cacheList = [CACHE_VENDOR];

function MapStateToProps(state) {
    return {
        meta: getMeta(state),
        data: getList(state),

        loaded: isLoaded(state) && isCacheLoaded(state, cacheList),
        loading: isLoading(state) || isCacheLoading(state, cacheList),
        actionLoading: isSecondaryLoading(state),
        error: getError(state),

        vendors: getVendorsForSelect(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadCache: () => loadCache(cacheList)(dispatch),
        list: (query) => dispatch(list(query)),
        accept: (id) => dispatch(accept(id)),
        remove: (id) => dispatch(remove(id)),
        downloadScorecard: (id, name) => dispatch(downloadScorecard(id, name)),
        reset: () => dispatch(reset()),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(listContainer(Tabla, { active: 1 }, basicColumns));
